import axios from './request'

const URL = {
  creditPurchase: { // 信用采购
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryCreditPurchase.magpie'
  },
  deferredPayment: { // 延期支付
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryExtensionPay.magpie'
  },
  depositPurchase: { // 定金采购
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryDeposit.magpie'
  },
  overpurchase: { // 超额采购
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryExcessPurchase.magpie'
  },
  preSaleContract: { // 预售合同
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryContract.magpie'
  }
}

class ProductLine {
  /**
   * retrieve for creditPurchase 信用采购
   */
  creditPurchase (params) {
    const url = URL.creditPurchase.retrieve

    return axios.post(url, params)
  }
  /**
   * retrieve for deferredPayment 延期支付
   */
  deferredPayment (params) {
    const url = URL.deferredPayment.retrieve

    return axios.post(url, params)
  }
  /**
   * retrieve for depositPurchase 定金采购
   */
  depositPurchase (params) {
    const url = URL.depositPurchase.retrieve

    return axios.post(url, params)
  }
  /**
   * retrieve for overpurchase 超额采购
   */
  overpurchase (params) {
    const url = URL.overpurchase.retrieve

    return axios.post(url, params)
  }
  /**
   * retrieve for preSaleContract 预售合同查询
   */
  preSaleContract (params) {
    const url = URL.preSaleContract.retrieve

    return axios.post(url, params)
  }
}

export default new ProductLine()
